import { ChangeEvent, FC } from 'react';
import {
  Button,
  Checkbox,
  PopoverBody,
  PopoverFooter,
  PopoverHeader,
  Stack,
} from '@chakra-ui/react';

import { Role } from '../../graphql/generated';
import { FilterMenu } from '../filter-menu/filter-menu';

type RoleFilterProps = {
  onSelectAll: () => void;
  onDeselectAll: () => void;
  selectedRoles: string[];
  onChange: (value: string) => void;
  roles: Role[];
};

export const RoleFilter: FC<RoleFilterProps> = ({
  roles,
  onChange,
  onDeselectAll,
  selectedRoles,
}) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.currentTarget.value);
  };

  return (
    <FilterMenu label="Roles" numOfSelectedItems={selectedRoles.length}>
      <PopoverHeader display="flex" justifyContent="space-between">
        <Button
          size="sm"
          variant="link"
          colorScheme="blue"
          justifyContent="start"
          onClick={onDeselectAll}
          disabled={!selectedRoles.length}
        >
          Deselect All
        </Button>
      </PopoverHeader>
      <PopoverBody minW="60">
        <Stack>
          {roles.map((role) => (
            <Checkbox
              size="md"
              key={role.id}
              value={role.id}
              onChange={handleChange}
              data-testid={`role-${role.id}`}
              isChecked={selectedRoles.includes(role.id)}
            >
              {role.id}
            </Checkbox>
          ))}
        </Stack>
      </PopoverBody>
      <PopoverFooter display="flex" justifyContent="space-between">
        <Button
          size="sm"
          variant="link"
          colorScheme="blue"
          justifyContent="start"
          onClick={onDeselectAll}
          disabled={!selectedRoles.length}
        >
          Deselect All
        </Button>
      </PopoverFooter>
    </FilterMenu>
  );
};
